<template>
  <div>
    <div class="img-wrap">
      <img
        alt=""
        :src="
          `${baseUrl}slides/${$route.params.locale}/${
            section.index
          }_${('000' + $route.params.id).slice(-2)}.jpg`
        "
      />
      <template v-if="slideVideo">
        <div
          v-if="slideVideo.url.startsWith('http')"
          class="videoIframe"
          :style="{
            left: slideVideo.left,
            top: slideVideo.top,
          }"
        >
          <div class="iframeWrapper">
            <iframe
              width="100%"
              height="100%"
              :src="slideVideo.url"
              frameborder="0"
              wmode="opaque"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
        <hls-video
          v-else
          :key="slideVideo.url"
          class="video"
          :style="{
            left: slideVideo.left,
            top: slideVideo.top,
          }"
          :source="`${baseUrl}videos/${slideVideo.url}`"
        />
      </template>
    </div>
    <a class="pdf" :href="`/slides/${$route.params.locale}/report.pdf${pdfPage}`">{{ $t('zobacz_pdf') }}</a>
    <router-link class="prev" :to="linkPrev" />
    <router-link class="next" :to="linkNext" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    HlsVideo: () => import('@/components/HlsVideo')
  },
  computed: {
    ...mapGetters(['baseUrl', 'sections']),
    sectionNames () {
      return Object.keys(this.sections)
    },
    sectionCurrent () {
      return this.$route.params.group
    },
    section () {
      return Object.values(this.sections).find(s => s.slug[this.$route.params.locale] === this.$route.params.group)
    },
    sectionNext () {
      const index = this.section.index % this.sectionNames.length + 1
      return Object.values(this.sections).find(s => s.index === index)
    },
    sectionPrev () {
      const index =
        (this.section.index + this.sectionNames.length - 2) %
        this.sectionNames.length + 1
      return Object.values(this.sections).find(s => s.index === index)
    },
    slideVideo () {
      return (
        this.section.videos &&
        this.section.videos[this.$route.params.id] &&
        this.section.videos[this.$route.params.id][
          this.$route.params.locale
        ]
      )
    },
    firstSlide () {
      return this.$route.params.id === 1 && this.section.index === 1
    },
    linkNext () {
      const lastSlide =
        this.$route.params.id < this.section.slides
      return {
        name:
          (lastSlide ? this.section : this.sectionNext)
            .layout || 'slide',
        params: Object.assign(
          {},
          {
            group: (lastSlide ? this.section : this.sectionNext).slug[this.$route.params.locale],
            id: lastSlide ? Number(this.$route.params.id) + 1 : 1
          },
          this.sectionNext.props || {}
        )
      }
    },
    linkPrev () {
      const firstSlide = this.$route.params.id > 1
      return {
        name:
          (firstSlide ? this.section : this.sectionPrev)
            .layout || 'slide',
        params: Object.assign(
          {},
          {
            group: (firstSlide ? this.section : this.sectionPrev).slug[this.$route.params.locale],
            id: firstSlide
              ? Number(this.$route.params.id) - 1
              : this.sectionPrev.slides
          },
          this.sectionPrev.props || {}
        )
      }
    },
    pdfPage () {
      if (this.section.pdf) {
        return `#page=${this.section.pdf}`
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
$mobile-breakpoint: 960px;

img {
  max-width: 100%;
  max-height: calc(100vh - 10rem);
  @media screen and (min-width: 605px) and (max-width: $mobile-breakpoint) {
    max-height: calc(100vh - 6rem);
  }
  @media screen and (min-width: $mobile-breakpoint + 1) {
    max-height: 100vh;
  }
}
.pdf,
.prev,
.next {
  display: block;
  position: absolute;
  top: 1rem;
  width: 3rem;
  height: 3rem;
  background-color: #e41e2b;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  text-indent: -9999px;
}
.pdf {
  right: 8rem;
  width: 8rem;
  line-height: calc(3rem - 4px);
  background: rgba(255,255,255,0.7);
  text-indent: 0;
  text-decoration: none;
  color: #e41e2b;
  text-align: center;
  border: 2px solid #e41e2b;
  font-weight: bold;
}
.pdf:hover {
  color: #fff;
  background-color: #e41e2b;
}
.prev {
  right: 4.5rem;
  background-color: #ccc;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%22-10%20-10%2045.141%2042.908%22%3E%3Cpath%20transform%3D%22scale%28-1%2C1%29%20translate%28-23.141%2C%200%29%22%20fill%3D%22%23FFF%22%20d%3D%22M0%2022.908V0l25.141%2011.454z%22%2F%3E%3C%2Fsvg%3E");
}
.prev:hover {
  background-color: #e41e2b;
}
.next {
  right: 1rem;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%22-10%20-10%2045.141%2042.908%22%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M0%2022.908V0l25.141%2011.454z%22%2F%3E%3C%2Fsvg%3E");
}
.next:hover {
  background-color: #ccc;
}
.img-wrap {
  position: relative;
}
.video {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 4rem;
  width: calc(50% - 3rem);
}
.videoIframe {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 4rem;
  width: calc(50% - 3rem);
}
.iframeWrapper {
  position: relative;
  height: 0;
  padding-bottom: 56.25%;
  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
</style>
